import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import { LinkContext } from "../../LinkProvider";

import ctaCoins from "../../img/trading/cta-coins.webp";

function CTASection() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt mb-[80px] lg:mb-[200px]">
      <div className="glcontainer">
        <Fade triggerOnce direction="up" duration={700}>
        <div className="relative lg:pt-[33px]">
          <div className="relative bg-[#30425a] rounded-[20px] lg:rounded-[40px] overflow-hidden px-[20px] py-[30px] lg:px-[70px] lg:py-[65px]">
            {/* Текст слева */}
            <div className="relative z-10 max-w-[549px] mx-auto lg:mx-0 flex flex-col gap-[35px] text-center lg:text-left items-center lg:items-start">
              <div className="flex flex-col gap-[15px]">
                <div className="flex flex-col gap-[4px]">
                  <h2 className="font-42-28 !text-white whitespace-nowrap max-lg:whitespace-normal">
                    {t("trading.cta.title1")}
                  </h2>
                  <h3 className="font-32-22 !text-white">{t("trading.cta.title2")}</h3>
                </div>
                <p className="font-16-14 !text-white max-w-[497px]">{t("trading.cta.subtitle")}</p>
              </div>

              <a
                href={link}
                className="inline-flex w-fit items-center justify-center px-[28px] lg:px-[42px] py-[12px] lg:py-[18px] rounded-[40px] border border-white font-['Inter'] font-bold text-[14px] lg:text-[16px] text-white capitalize backdrop-blur-[15px] hover:opacity-90 transition-opacity"
                style={{
                  backgroundImage:
                    "linear-gradient(-84deg, rgba(255,255,255,0.4) 6%, rgba(204,222,255,0.4) 66%)",
                }}
              >
                {t("trading.cta.btn")}
              </a>
            </div>

            {/* Mobile: монеты под кнопкой */}
            <div className="lg:hidden mt-[25px] -mb-[30px] flex justify-center">
              <img
                src={ctaCoins}
                alt=""
                aria-hidden
                className="w-[84%] max-w-[300px] object-cover object-top"
              />
            </div>
          </div>

          {/* Desktop: монеты выступают над карточкой */}
          <div className="hidden lg:block absolute left-[57.4%] top-0 bottom-0 w-[40.9%] pointer-events-none overflow-hidden">
            <img
              src={ctaCoins}
              alt=""
              aria-hidden
              className="absolute w-[133.3%] max-w-none left-[-19.8%] top-[-35.7%]"
            />
          </div>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default CTASection;
